import useRolePermission from "entities/auth/hooks/useRolePermission";
import { useLanguagesQuery } from "entities/translations/queries/useLanguages";
import UnpublishedWarn from "modules/translations/components/UnpublishedWarn";
import PageFilterBar from "modules/translations/pages/StaticTranslations/components/PageFilterBar";
import FlexColumn from "shared/components/Layout/components/FlexColumn";
import PageHeading from "shared/components/PageHeading";
import PrimaryButton from "shared/components/PrimaryButton";
import TranslationTable from "shared/components/TranslationTable";
import {
  StaticTranslationsProvider,
  useStaticTranslationPage,
} from "./context";
import { getStaticTranslationsColumns } from "./helpers";
import { StyledAlert } from "./styled";
import { StaticTranslationsTableData } from "./types";

const StaticTranslationsContainer = () => (
  <StaticTranslationsProvider>
    <StaticTranslationsPage />
  </StaticTranslationsProvider>
);

const StaticTranslationsPage = () => {
  const {
    tableData,
    isDisabledPublish,
    totalAmountUnpublishedChanges,
    isPendingPublish,
    isAutoTranslationLoaded,
    hasShownTranslateMessageError,
    autoTranslateErrorMessage,
    updatedTranslations,
    handlePublishChanges,
    handleUpdatedTranslations,
    setShownTranslateMessageError,
    handleAutoTranslate,
    isLoadingTable,
    targetLanguage,
  } = useStaticTranslationPage();
  const { data: languages, isLoading: isLoadingLanguages } =
    useLanguagesQuery();
  const writeAccess = useRolePermission("translations:write");

  const columns = getStaticTranslationsColumns({
    updatedTranslations,
    handleUpdatedTranslations,
    handleAutoTranslate,
    isLoading: isAutoTranslationLoaded || isLoadingLanguages,
    readOnly: !writeAccess.allowed,
    allLanguages: languages || [],
    targetLanguage,
  });

  return (
    <FlexColumn data-text="static wrap">
      <PageHeading>
        {writeAccess.allowed && (
          <FlexColumn alignSelf="flex-end" position="relative">
            <PrimaryButton
              title="Publish Changes"
              size="medium"
              disabled={isDisabledPublish}
              loading={isPendingPublish}
              onClick={handlePublishChanges}
            />
            {Boolean(totalAmountUnpublishedChanges) && (
              <UnpublishedWarn totalChanges={totalAmountUnpublishedChanges} />
            )}
          </FlexColumn>
        )}
      </PageHeading>
      <PageFilterBar />
      <TranslationTable<StaticTranslationsTableData>
        columns={columns}
        emptyStateMessage="No Results Found"
        data={tableData.data}
        heightTable={"78vh"}
        pageSizeOptions={[25, 50, 100]}
        paginationModel={tableData.paginationModel}
        onPaginationModelChange={tableData.setPaginationModel}
        loading={isLoadingTable || isAutoTranslationLoaded}
      />
      {hasShownTranslateMessageError && (
        <StyledAlert
          severity="info"
          onClose={() => {
            setShownTranslateMessageError(false);
          }}
        >
          {autoTranslateErrorMessage}
        </StyledAlert>
      )}
    </FlexColumn>
  );
};
export default StaticTranslationsContainer;
